const getApiBaseUrl = () => {
    // Wenn wir auf dem eigenen PC sind (Localhost)
    console.log("DEBUG: Hostname ist", window.location.hostname);
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        console.log("DEBUG: Wähle Localhost-Modus");
        return "http://localhost:1999";
    }
    // Wenn wir irgendwo anders sind (Azure/Internet)
    else {
        // WICHTIG: Hier muss die URL deines Python-Backends stehen!
        // Läuft dein Backend unter search.copatools.com? Dann ist das hier korrekt:
        console.log("DEBUG: Wähle Production-Modus");
        return "https://searchapi.copatools.com";
    }
};

export const handleSearch = async (searchQuery, page, setSearchResults, setInitialSearchInitiated, token, auth) => {
    try {

        const baseUrl = getApiBaseUrl();
        const url = `${baseUrl}/search?q=${searchQuery}&page=${page}`;

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` // "new key"
           // 'x-api-key': apiKey
        };

        const response = await fetch(url, {
            method: 'GET',
            headers: headers
        });

        if (response.status === 401) {
            console.warn("Session abgelaufen! Redirect zum Login...");
            // Trigger den OneLogin Redirect
            if (auth) {
                await auth.signinRedirect();
            }
            return;
        }

        if (!response.ok) {
            throw new Error(`Failed to fetch: ${response.statusText}`);
        }

        const data = await response.json();
        console.log('Search results:', data);
        setInitialSearchInitiated(true);
        setSearchResults(data.results);

        return { totalHits: data.total_hits, processingTime: data.processing_time }; // Return total hits and processing time
    } catch (error) {
        console.error('Error searching:', error.message);
    }
};

export const handleDeepSearch = (searchQuery, setDeepSearchOutput, token) => {
    try {

        const baseUrl = getApiBaseUrl();
        const url = `${baseUrl}/deepsearch?q=${encodeURIComponent(searchQuery)}&token=${token}`;

        const eventSource = new EventSource(url);

        eventSource.onopen = () => {
            console.log("Deep search stream opened");
        };

        eventSource.onmessage = (event) => {
            console.log("Received deep search message:", event.data);
            setDeepSearchOutput(prev => [...prev, event.data]);
        };

        eventSource.onerror = (err) => {
            console.error("Deep search stream error:", err);
            eventSource.close();
        };

        return eventSource;
    } catch (error) {
        console.error('Error in deep search:', error.message);
    }
};


export const handleKeyPress = (e, handleSearch) => {
    if (e.key === 'Enter') {
        handleSearch();
    }
};

export const filterResults = (searchResults, filters, setFilteredResults) => {
    const filtered = searchResults.filter(result => {
        if (filters.DevOps && result.type === "DevOps") {
            return true;
        }
        if (filters.OnlineHelp && result.type === "Online Help") {
            return true;
        }
        if (filters.SunriseTicket && result.type === "Sunrise Ticket") {
            return true;
        }
        if (filters.ZohoTickets && result.type === "zoho Ticket") {
            return true;
        }
        return false;
    });
    setFilteredResults(filtered);
};
